@if (review) {
  <mat-card appearance="outlined" class="capture-event-review-detail-map-popup">
    <mat-card-content fxLayout="row">
      <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start" fxFlex="100%"
        (selectedTabChange)="selectReview(+$event.tab.textLabel)" [(selectedIndex)]="activeTab"
        animationDuration="0ms">
        @for (view of captureEvent.views; track view) {
          <div>
            @for (tabReview of view.reviews; track tabReview) {
              <mat-tab label="{{tabReview.id}}">
                <ng-template mat-tab-label>
                  <div fxLayoutAlign="center center">
                    {{view.viewType | startCase}} {{tabReview.reviewType?.toLowerCase() === 'neurala' ? '(Neurala)' : ''}}
                    @if (tabReview.isUrgent) {
                      <mat-icon class="mat-warn hazard-icon" matTooltip="Urgent Hazards Detected">
                        warning
                      </mat-icon>
                    }
                    @if (!tabReview.isUrgent && tabReview.hazards.length > 0) {
                      <mat-icon class="hazard-icon hazard-only"
                        matTooltip="Hazards Detected">warning
                      </mat-icon>
                    }
                  </div>
                </ng-template>
                <div fxLayout="row" fxLayout.lt-sm="column" fxLayoutGap="10px">
                  <div class="review-popup-info" fxLayout="column" fxFlexOrder.lt-sm="2">
                    <ng-container
                    *ngTemplateOutlet="reviewDetailTemplate; context: { $implicit: tabReview }"></ng-container>
                    @if (review.hazards.length > 0) {
                      <mat-list class="">
                        <mat-list-item>
                          <span matListItemTitle>
                            Hazards
                            @if (tabReview.isUrgent) {
                              <mat-icon class="mat-warn hazard-icon"
                                matTooltip="Urgent Hazards Detected">warning
                              </mat-icon>
                            }
                            @if (!tabReview.isUrgent && tabReview.hazards.length > 0) {
                              <mat-icon
                                class="hazard-icon hazard-only"
                                matTooltip="Hazards Detected">warning
                              </mat-icon>
                            }
                          </span>
                        </mat-list-item>
                        <mat-list-item>
                          @for (hazard of review.hazards; track hazard) {
                            <span matListItemLine>{{hazard | startCase}}</span>
                          }
                        </mat-list-item>
                      </mat-list>
                    }
                  </div>
                  <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start" class="imageTabGroup" fxFlexOrder.lt-sm="1"
                    animationDuration="0ms">
                    @for (image of review.images; track image) {
                      <mat-tab label="{{getImageLabel(image.camera_label) | startCase}}">
                        <img src="{{image.url}}" alt="review image"/>
                      </mat-tab>
                    }
                  </mat-tab-group>
                </div>
              </mat-tab>
            }
          </div>
        }
      </mat-tab-group>
      <div fxFlex="40px">
        <button mat-icon-button (click)="onClose()">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </mat-card-content>
  </mat-card>
}
